import { render, staticRenderFns } from "./PortfolioPageTabs.vue?vue&type=template&id=1cfcfc03&scoped=true"
import script from "./PortfolioPageTabs.vue?vue&type=script&lang=js"
export * from "./PortfolioPageTabs.vue?vue&type=script&lang=js"
import style0 from "./PortfolioPageTabs.vue?vue&type=style&index=0&id=1cfcfc03&prod&lang=scss&scoped=true"
import style1 from "./PortfolioPageTabs.vue?vue&type=style&index=1&id=1cfcfc03&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfcfc03",
  null
  
)

export default component.exports